import http from '../helpers/http';
import { patientIdentity } from '../helpers/patientIdentity';

export function availabilityParams(schedule, place, specialtyId) {
  return {
    id_place: place.id_place,
    id_city: place.id_city,
    id_prof: schedule.id_prof,
    id_spec: specialtyId,
    id_paymeth: schedule.id_paymeth,
    id_insurance: schedule.id_insurance || null,
  };
}

export function loadSchedulingSpecialties(schedule, place) {
  return http.get(`/places/${place.id_place}/professionals/${schedule.id_prof}/specialties`).then(response => response.data);
}

export function loadSchedulingDates(params, startDate) {
  return http.get('/schedule/availabilities', {
    params: { ...params, start_date: startDate, start_end_days: 32 },
  }).then(response => response.data);
}

export function loadSchedulingTimes(params, date) {
  return http.get('/schedule/availabilities/times', {
    params: { ...params, available_date: date },
  }).then(response => response.data);
}

export function createAttendanceSchedule(schedule, place, form, slot) {
  const patient = schedule.patient;
  return http.post(`/places/${place.id_place}/schedules`, {
    ...availabilityParams(schedule, place, form.specialtyId),
    ...patientIdentity(patient),
    id_patient: schedule.id_patient,
    sched_patient_name: patient.patient_name,
    sched_patient_cpf: patient.patient_cpf || '',
    sched_patient_phone: patient.patient_phone || schedule.sched_patient_phone,
    sched_patient_birthdate: patient.patient_birthdate,
    sched_date: form.date,
    sched_time: slot.available_time,
    id_avail: slot.id_avail || null,
    id_place_location: slot.id_place_location || null,
    sched_obs: form.observation,
    sched_by: 'PL',
    sched_type: 'NV',
    sched_is_fitted: false,
    avail_online: schedule.sched_online || false,
    participants: [],
    sched_value: '',
  });
}
